import Vue from 'vue'
import ViewUI, { Input } from 'view-design'
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import 'view-design/dist/styles/iview.css'
import '@/assets/css/style.less'
import '@/assets/css/modal.less'
// import Viewer from 'v-viewer' //
// import 'viewerjs/dist/viewer.css' //
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// eslint-disable-next-line import/extensions
import { Upload, Image } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import VueAMap from 'vue-amap' //
import globalTools from './utils/globalTools'
import store from './store'
import bus from './utils/bus'
import App from './App'
import router from './router'
// import 'amfe-flexible'; // 为html、body添加font-size，窗口调整时候重新设置font-size
import 'static/js/rem'
import limit from './utils/limit'

import Nodata from './components/noData'
import BlockTitle from './components/blockTitle'
import './plugins/index'

Vue.prototype.$tools = globalTools
// eslint-disable-next-line import/no-named-as-default-member
globalTools.init()
// Vue.prototype.$Nodata = Nodata
Vue.prototype.NProgress = NProgress
Vue.prototype.$store = store
Vue.prototype.$echarts = echarts
Vue.prototype.$bus = bus
Vue.prototype.$swiper = Swiper
Vue.prototype.$limit = limit
// Vue.use(pdf)
Vue.use(Vuex)
Vue.use(ViewUI)
Vue.use(Upload)
// Vue.use(Dialog)
Vue.use(Image)
// Vue.use(Viewer)
Vue.component('oInput', Input)
Vue.component('Nodata', Nodata)
Vue.component('BlockTitle', BlockTitle)
Vue.use(VueAMap)
// Vue.use(Nodata)


Vue.config.productionTip = false

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '5bfe7e37d7ec5580e92fb8a7e119154e',
  // 插件集合
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'Geolocation',
    'AMap.DistrictSearch'
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
})
new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
